import {Button, Menu} from '@mantine/core'
import {notifications} from '@mantine/notifications'
import {IconChevronDown, IconFileSpreadsheet} from '@tabler/icons-react'

import {useDispatchYards} from '../dispatch/use-dispatch'
import {useDownloadInventoryCsv} from './use-equipment-checks'

export function InventoryExportMenu() {
    const {data: yards = []} = useDispatchYards()
    const download = useDownloadInventoryCsv()

    function exportFor(yardId: string | null) {
        download.mutate(yardId, {
            onError: (error) =>
                notifications.show({
                    color: 'red',
                    title: 'Could not export the inventory',
                    message: error.message || 'Please try again.',
                }),
        })
    }

    return (
        <Menu position="bottom-end">
            <Menu.Target>
                <Button
                    variant="default"
                    loading={download.isPending}
                    leftSection={<IconFileSpreadsheet size={16} stroke={1.5} />}
                    rightSection={<IconChevronDown size={14} />}
                >
                    Export inventory
                </Button>
            </Menu.Target>
            <Menu.Dropdown>
                <Menu.Item onClick={() => exportFor(null)}>All yards</Menu.Item>
                {yards.map((yard) => (
                    <Menu.Item key={yard.id} onClick={() => exportFor(yard.id)}>
                        {yard.name}
                    </Menu.Item>
                ))}
            </Menu.Dropdown>
        </Menu>
    )
}
